import React, { useState } from 'react';
import { useController } from './controller';
import * as S from './styles';

const BetterExplain = (props: {setActive: Function, active: boolean, term?: string, explanation?: string }) => {
    const controller = useController();

    return props.active && props.active == true ? (
        <S.main>
            <S.modal>
                <S.header>
                    <S.headerTitle>{props.term}</S.headerTitle>
                    <S.close icon={controller.general.icons.faXmark} onClick={() => {
                        props.setActive(false);
                    }}/>
                </S.header>
                <S.explanation dangerouslySetInnerHTML={{__html: props.explanation ? props.explanation.replace(/\\n/g, '') : ''}}></S.explanation>
            </S.modal>
        </S.main>
    ) : null;
}

export default BetterExplain;